import { render, staticRenderFns } from "./ButtonOrderDetails.vue?vue&type=template&id=68da4dcd&scoped=true&"
import script from "./ButtonOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ButtonOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da4dcd",
  null
  
)

export default component.exports